export { default } from './slide-record-value'
